import React from 'react';

/**
 * ModalHeader Component
 *
 * Unified header component for all modals (creation, details, edit).
 * Provides consistent styling, padding, and close button visibility.
 *
 * @param {string} title - The title text to display
 * @param {Function} onClose - Callback function when close button is clicked
 * @param {string} variant - 'creation' | 'details' - Determines styling variant
 * @param {React.ReactNode} titleSuffix - Optional node after the title
 * @param {React.ReactNode} headerActions - Optional actions before the close button
 */
const ModalHeader = ({
  title,
  onClose,
  variant = 'details', // 'creation' | 'details'
  titleSuffix,
  headerActions = null,
}) => {
  return (
    <div className={`modal-header modal-header--${variant}`}>
      <div className="modal-header-title-row">
        <h2 className="modal-header-title">
          {title}
        </h2>
        {titleSuffix}
      </div>
      <div className="modal-header-actions">
        {headerActions}
        <button
          type="button"
          className="close-button"
          onClick={onClose}
          aria-label="Close modal"
        >
          <i className="fi fi-rr-circle-xmark" aria-hidden="true"></i>
        </button>
      </div>
    </div>
  );
};

export default ModalHeader;
